import React from 'react';

const AwningsPromotionBanner: React.FC = () => {
  return (
    <div className="bg-sale text-white text-center py-2">
      <div className="max-w-7xl mx-auto px-4">
        <p className="font-semibold">
          🌞 Summer Bonus: Choose Any Premium Sunbrella Fabric — On Us ($600+ value) 🌞
        </p>
      </div>
    </div>
  );
};

export default AwningsPromotionBanner;
